var setupProductId = 42096798990487;

function checkCartForUid() { 
  setTimeout(function() {
  var cartData = '';
  var uidInCart = false;
  var setupProduct = false;  
  var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { 
       cartData = data;
       console.log(data);
       data.items.forEach(checkUID);
       data.items.forEach(checkSetup);
	   function checkUID(value, index, array) {
         if(value.product_type.indexOf('UID') != -1) {
            uidInCart = true;
            console.log('UID in cart');
         }  
       }
       function checkSetup(value, index, array) {
         if(value.product_type.indexOf('Setup') != -1) {
            setupProduct = true;
            console.log('Setup in cart');
         } 
       }
       executeCart(setupProduct, uidInCart, data);
     });
  }, 500);
}
checkCartForUid(); 

function executeCart(setupProduct, uidInCart, data) {
  if (uidInCart === true && setupProduct === false) {
     addSetup(); 
  }
  else if (uidInCart === false && setupProduct === true) {
     removeSetup(data);
  }
}

function addSetup() {
  var addData = {
    'id': setupProductId,
    'quantity': 1
  };

  fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest' 
    },
    method: 'POST'
   }).then(function(response) {
       return response.json();
   }).then(function(json) {
       console.log(json)
   }).catch(function(err) {
       console.error(err)
   });
        
   setTimeout(function() {
     goCart.fetchCart();
   },500); 
}

function removeSetup(data) {
  for (let i = 0; i < data.items.length; i++) {
    console.log(data.items[i].id);
    var cart_item_id = data.items[i].id.toString();
    if(cart_item_id.indexOf(setupProductId) != -1) {
      var data_line = data.items.indexOf(data.items[i]);
      var data_line_fixed = data_line;
      console.log(data_line_fixed);
      goCart.removeItem(1);
    }
  }
}


const container = document.querySelector('.go-cart-drawer__content');
  // Click handler for entire DIV container
container.addEventListener('click', function (e) {
    // But only alert for elements that have an alert-button class
  if (e.target.classList.contains('go-cart-item__quantity-button')) {
     checkCartForUid();
  }
  else if (e.target.classList.contains('go-cart-item__remove')) {
     checkCartForUid();
  }
});

var collection_cart_button = document.getElementsByClassName("add-to-cart-collection"); 
Array.from(collection_cart_button).forEach(function(element) {
   element.addEventListener('click', checkCartForUid);
});   

var cart_buttons = document.getElementsByClassName("go-cart--shipping"); 
Array.from(cart_buttons).forEach(function(element) {
   element.addEventListener('click', checkCartForUid);
});   


$(document).ready(function() {
  var location_pop = $('.location__overlay');

  $('.location__us').click(function() {
    document.cookie = "ALBEK=U";
    window.location.href = 'https://albek.us';
  });
      
  $('.location__eu').click(function() {
    document.cookie = "ALBEK=E";
    window.location.href = 'https://albek.eu';
  });
      
  $('.location__au').click(function() {
    document.cookie = "ALBEK=A";
    location_pop.removeClass('overlay__open');
  });


  $.ajax({
    url: "https://geolocation-db.com/jsonp",
    jsonpCallback: "callback",
    dataType: "jsonp",
    success: function( location ) {
      var locations = ["Australia","Fiji","Hong Kong","India","Indonesia","Japan","Macau","Malaysia","New Zealand","Philippines","Thailand","Singapore","South Korea","Vietnam"];
      console.log(location.country_name);
    
      if ($.inArray(location.country_name, locations) !== -1) {
        console.log('User in Australia')
      }
      else{
        if (document.cookie.split(';').some((item) => item.includes('ALBEK=A'))) {
      
        }
        else {
          location_pop.addClass('overlay__open');
        }
      }
    }
  });
});